import React, { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    RaceSummaryRowMarkets,
    RaceSummaryRowMarketsConfigType,
} from './templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets';
import { RaceSummaryMatchBetsState } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryMatchBets.state';
import { RowMarketsState } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets.state';

const viewConfig: RaceSummaryRowMarketsConfigType = {
    displayShowMoreButton: true,
    withTableHeader: false,
};

export interface RaceSummaryMatchBetsPropsType {
    eventId: EventId;
}

export const RaceSummaryMatchBets = observer('RaceSummaryMatchBets', (propsIn: RaceSummaryMatchBetsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const { eventId } = props;

    const [state] = useState(() => new RowMarketsState(new RaceSummaryMatchBetsState(props.eventId)));

    const currentEvent = eventId.getEventModel();
    if (currentEvent === null) {
        return null;
    }

    const sport = currentEvent.sport;
    const allHorseRaces = sport === 'horseracing';

    if (allHorseRaces) {
        return (
            <RaceSummaryRowMarkets
                eventId={props.eventId}
                state={state}
                config={viewConfig}
            />
        );
    }
    return null;
});
